// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1431":"4818f291","2781":"4818f291","6207":"1610167b"}[chunkId] + ".chunk.css";
};